import { useMaestriaContent } from "@/shared/i18n/LocaleContext";
import { MENTOR_SHAPE_LEFT, MENTOR_SHAPE_RIGHT } from "./mentorShapes";
import styles from "./Mentors.module.css";

/*
 * O fundo de cada mentor e um vetor 486x310 com stroke OUTSIDE de 17px. Em SVG
 * isso vira stroke-width 34 desenhado antes do preenchimento (paint-order), que
 * cobre a metade interna — o mesmo resultado do Figma.
 */
function ShapeBackdrop({ id, path, src }: Readonly<{ id: string; path: string; src: string }>) {
  return (
    <svg
      className={styles.backdrop}
      viewBox="-17 -17 520 344"
      width={520}
      height={344}
      aria-hidden="true"
      focusable="false"
    >
      <clipPath id={id}>
        <path d={path} />
      </clipPath>
      <path
        d={path}
        fill="none"
        stroke="#c81ef1"
        strokeOpacity="0.1"
        strokeWidth="34"
        strokeLinejoin="round"
      />
      <image
        href={src}
        x="0"
        y="0"
        width="486"
        height="310"
        preserveAspectRatio="none"
        clipPath={`url(#${id})`}
      />
    </svg>
  );
}

export function Mentors() {
  const { mentors } = useMaestriaContent();
  const [eduardo, lucas] = mentors.items;

  return (
    <section
      id="mentores"
      className={`maestria-section ${styles.section}`}
      aria-labelledby="mentors-title"
    >
      <div className={`maestria-container ${styles.inner}`}>
        <h2 id="mentors-title" className={styles.title}>
          {mentors.title}
        </h2>

        <div className={styles.stage}>
          <figure className={`${styles.mentor} ${styles.left}`}>
            <div className={styles.media}>
              <ShapeBackdrop
                id="mentor-shape-eduardo"
                path={MENTOR_SHAPE_LEFT}
                src={eduardo.backdrop}
              />
              <img
                className={styles.cutout}
                src={eduardo.image}
                alt={eduardo.imageAlt}
                width={504}
                height={391}
                loading="lazy"
              />
            </div>
            <figcaption className={styles.caption}>
              <p className={styles.name}>
                <strong>{eduardo.name}</strong>
                <span>{eduardo.role}</span>
              </p>
              {eduardo.bio ? <p className={styles.mentorBio}>{eduardo.bio}</p> : null}
            </figcaption>
          </figure>

          <figure className={`${styles.mentor} ${styles.right}`}>
            <div className={styles.media}>
              <ShapeBackdrop
                id="mentor-shape-lucas"
                path={MENTOR_SHAPE_RIGHT}
                src={lucas.backdrop}
              />
              <img
                className={styles.cutout}
                src={lucas.image}
                alt={lucas.imageAlt}
                width={451}
                height={423}
                loading="lazy"
              />
            </div>
            <figcaption className={styles.caption}>
              <p className={styles.name}>
                <strong>{lucas.name}</strong>
                <span>{lucas.role}</span>
              </p>
              {lucas.bio ? <p className={styles.mentorBio}>{lucas.bio}</p> : null}
            </figcaption>
          </figure>
        </div>

        <p className={styles.bio}>{mentors.bio}</p>
      </div>
    </section>
  );
}
